import { Component } from '@angular/core';
import { LoadingOverlayService } from './loading-overlay.service';

@Component({
    selector: 'app-loader',
    template: `
        <div class="loader-overlay" *ngIf="loadingOverlayService.loaderState$ | async">
            <mat-spinner diameter="60"></mat-spinner>
        </div>
    `,
    styleUrls: ['./loading-overlay.component.scss']
})
export class LoaderComponent {
    constructor(public loadingOverlayService: LoadingOverlayService) {}
}
